import React from "react";
import { useParams, Link } from "react-router-dom";
import blog1 from '../assets/images/post-image1.jpg'
import { useSelector } from "react-redux";
import { backendUrl } from "../url";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
export default function SingleBlog() {
    const { selectedBlog } = useSelector((state) => state.blog);
    // Format date like “Jul 11, 2022”
    const formattedDate = new Date(selectedBlog.createdOn).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
    });

    return (
        <section className="blog-single py-5">
            <div className="container">
                {/* Header / Banner */}
                <div className="blog-header text-center mb-5">

                    <h1 className="display-5 fw-bold mb-3">{selectedBlog.title}</h1>

                </div>

                {/* Image */}
                <div className="blog-image mb-2">
                    <img
                        src={`${backendUrl}/uploads/blogs/${selectedBlog.imagePath}`}
                        alt={selectedBlog.title}
                        className="img-fluid shadow-sm w-100"
                        style={{ maxHeight: "450px", objectFit: "cover" }}
                    />
                </div>
                <div className="blog-category text-uppercase text-muted small mb-5">
                    {selectedBlog.category} / {formattedDate}
                </div>
                <div className="text-secondary"></div>

                {/* Blog Content */}
                {/* <div
                    className="blog-content fs-5 lh-lg text-secondary"
                    dangerouslySetInnerHTML={{ __html: selectedBlog.content }}
                /> */}
                <ReactMarkdown
                    remarkPlugins={[remarkGfm]}
                    components={{
                        p: ({ node, ...props }) => <p className="mb-3" {...props} />,
                        strong: ({ node, ...props }) => <strong className="fw-semibold" {...props} />,
                        h2: ({ node, ...props }) => <h2 className="mt-4 mb-2 fw-bold" {...props} />,
                        h3: ({ node, ...props }) => <h3 className="mt-3 mb-2 fw-semibold" {...props} />,
                        blockquote: ({ node, ...props }) => (
                            <blockquote className="border-start ps-3 text-muted fst-italic" {...props} />
                        ),
                    }}
                >
                    {selectedBlog.content}
                </ReactMarkdown>

                {/* Footer */}
                <div className="mt-5 text-center">
                    <Link to="/blogs" className="btn btn-dark text-uppercase px-4 py-2">
                        ← Back to Blogs
                    </Link>
                </div>
            </div>
        </section>
    );
}
